import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-markdown-renderer',
  templateUrl: './markdown-renderer.component.html',
  styleUrl: './markdown-renderer.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class MarkdownRendererComponent {
  @Input() markdown: string = '';
}
